import { useEffect, useState } from "react";
import {
  useDebugStack,
  setDebugStackForNextSubscription,
} from "../../lib/reflux/monitoring-hooks";

export default function useStoreState(store, storeStateFunc, initialStateFunc) {
  const [storeData, setStoreState] = useState({
    state: initialStateFunc ? initialStateFunc() : storeStateFunc(),
  });

  // Capture stack during render (when calling component is on the stack)
  const debugStack = useDebugStack();

  useEffect(() => {
    const handleStoreChange = (newState) => {
      const updatedState = storeStateFunc ? storeStateFunc() : newState;
      // bail out when the selector returns the same reference so unrelated
      // store triggers don't force a render
      setStoreState((prev) =>
        prev.state === updatedState ? prev : { state: updatedState },
      );
    };

    // Set the debug stack for memory tracking before subscribing
    setDebugStackForNextSubscription(debugStack);
    const unsubscribe = store.listen(handleStoreChange);

    return unsubscribe;
  }, []);

  return storeData.state;
}
